import React, { useEffect } from 'react';
import { Container, Row, Col, Form, Card, InputGroup, Button } from 'react-bootstrap';
import './ConsentDataInput.css';
import AlertDialog from 'components/Alerts/AlertDialog';

const ConsentDataInput = ({
  onContinue,
  phone,
  email,
  setPhone,
  setEmail,
  serverError,
  onPreview,
  consentPreview,
  onCleanError
}) => {
  const [errorPhone, setErrorPhone] = React.useState('');

  const handleSplitPhone = () => {
    const phoneSplit = phone.split(' ');
    if (phoneSplit.length > 1) {
      return phoneSplit[1];
    } else {
      return phoneSplit[0];
    }
  }

  const handleSubmitData = () => {
    const validPhone = handleSplitPhone();
    if (validPhone.length !== 9) {
      setErrorPhone('Debe ingresar un número de teléfono válido');
      return;
    }
    if (validPhone.length === 9) {
      setErrorPhone('');
      setPhone(`56 ${validPhone}`);
    }
    onContinue();
  }

  useEffect(() => {
    if (consentPreview) {
      window.open(consentPreview, '_blank');
    }
  }, [consentPreview]);


  return (
    <Container className="mb-5">
      <Row className="justify-content-md-center ">
        <Col md={6}>
          <Card className='consent-card'>
            <Card.Title className='consent-card-title'>Consentimiento Informado</Card.Title>
            <Card.Body className='consent-card-body'>
              <div className="d-flex flex-column justify-content-start">
                <p className=''>
                  En happ cuidamos y entregamos máxima seguridad sobre los datos de nuestros usuarios. Para poder realizar tu chequeo preventivo, es necesario que leas y aceptes un Consentimiento Informado.
                </p>
              </div>
              <div>
                <ul>
                  <li>Recibirás el Consentimiento en tu correo para que puedas leerlo</li>
                  <li>Te enviaremos un código de 4 dígitos por SMS para confirmar tu firma</li>
                </ul>
                <h6 className="consent-card-text">Revisa tus datos antes de continuar</h6>
              </div>
              <Form.Group controlId="customInput" className="mb-4 mt-4 ">
                <InputGroup >
                  <InputGroup.Text className='data-input-text'>Teléfono Movil +56</InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="987654321"
                    className='data-input-text'
                    value={handleSplitPhone()}
                    onChange={(e) => setPhone(e.target.value)}
                    maxLength={9}
                  />
                </InputGroup>
                {errorPhone && <p style={{ color: '#FA0F00', fontWeight: 'bold', fontSize: '12px', marginLeft: '4px' }}>{errorPhone}</p>}
                <InputGroup className='mt-4'>
                  <InputGroup.Text className='data-input-text'>Correo electrónico:</InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="happ@gmail.com"
                    className='data-input-text'
                    value={email || ''}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </InputGroup>
              </Form.Group>
              <div className="consent-button-row">
                <Button
                  className='primary text-primary consent-button'
                  style={{ backgroundColor: 'white', borderColor: 'primary' }}
                  type="button"
                  onClick={() => onPreview()}
                >
                  Ver Consentimiento
                </Button>
                <Button
                  variant='primary'
                  className='consent-button'
                  onClick={() => handleSubmitData()}
                >Confirmar datos</Button>
              </div>
            </Card.Body>
          </Card>

        </Col>
        <AlertDialog
          show={serverError}
          title={"Error al enviar datos"}
          bodyMessage={"Ocurrió un error al enviar los datos, por favor revisa los datos ingresados e intenta nuevamente."}
          buttonName={"Volver"}
          buttonFunction={() => { onCleanError() }}
          onHide={() => { onCleanError() }}
          error={true}
        />
      </Row>
    </Container>
  );
};

export default ConsentDataInput;
